module.exports = __webpack_public_path__ + "static/media/019-Kissen_ID_7.e32747d5.mp3";